<template>
  <v-layout wrap>
    <v-flex xs12 md12 v-if="embedded">
      <v-autocomplete
        box dense persistent-hint
        :items="items"
        :label="fieldLabel"
        :hint="hintText"
        :disabled="readonly"
        v-model="selection"
        no-data-text="No results"
        clear-icon="cancel"
        append-icon="keyboard_arrow_down">
      </v-autocomplete>
    </v-flex>
    <v-flex xs12 md6 v-else>
      <v-autocomplete
        box dense persistent-hint
        :items="items"
        :label="fieldLabel"
        :hint="hintText"
        :disabled="readonly"
        v-model="selection"
        no-data-text="No results"
        append-icon="keyboard_arrow_down">
      </v-autocomplete>
    </v-flex>

  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: 'select-field',
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    },
    caseType: {
      type: Object,
      required: true
    }
  },
  computed: {
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    name() {
      if (this.field && this.field.name) {
        return this.field.name
      } else {
        return ""
      }
    },
    hintText() {
      if (this.field && this.field.guidance) { return this.field.guidance }
      return ""
    },
    items() {
      const opts = []
      if (this.caseType) {
        this.caseType.statuses.forEach(status => {
          opts.push({ text: status.state, value: { id: status.id, name: status.state } })
        })
      }
      return opts
    },
    selection: {
      get() {
        if (this.data) {
          const itemNames = this.items.map(item => item.text)
          const index = itemNames.indexOf(this.data)
          return this.items[index]
        }
        return undefined
      },
      set(value) {
        this.$emit('update-item', { field: "current_state", data: value.name, row: this.row })
        this.$emit('update-item', { field: "current_state_id", data: value.id, row: this.row })
        this.$emit("blurred", {
          field: "current_state",
          data: value.name,
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  }
}
</script>
